import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./installation-query-key-factory";

/**
 * Gets the installation project count
 */
export const getInstallationProjectCount = ({ installationId }: { installationId: string | null }) => {
  return installationId === null
    ? Promise.reject(new Error("Invalid id"))
    : Brm.installationApi.getInstallationProjectCount(installationId);
};

interface IInstallationProps {
  installationId: string | null;
  options?: QueryOption<typeof getInstallationProjectCount>;
}

/**
 * Custom hook for getting the installation project count
 *
 * @param {string} installationId - uuid of installation
 * @param {object} config - react-query configuration
 * @returns
 */
export const useInstallationProjectCount = ({ installationId, options = {} }: IInstallationProps) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.installationKeys.projectCount(installationId),
    queryFn: () => getInstallationProjectCount({ installationId }),
  });
};
